import { TestIdDomain } from 'constants/testIds';

const InviteCoBorrowerDrawerScope = `${TestIdDomain.BORROWERS}.invite-co-borrower-drawer`;

export const InviteCoBorrowerDrawerTestIds = {
  DRAWER: InviteCoBorrowerDrawerScope,
  EMAIL_INPUT: `${InviteCoBorrowerDrawerScope}.email-input`,
  SEPARATE_APPLICATION_SWITCH: `${InviteCoBorrowerDrawerScope}.separate-application-switch`,
  SUBMIT_BUTTON: `${InviteCoBorrowerDrawerScope}.submit-button`,
};

export const INVITE_CO_BORROWER_FORM_ID = 'invite-co-borrower-form';
export const INVITE_CO_BORROWER_DRAWER_TITLE = 'Invite Co-Borrower';
export const INVITE_CO_BORROWER_SUBMIT_BUTTON_LABEL = 'Send Invite';
export const INVITE_CO_BORROWER_EMAIL_ERROR_MESSAGE = 'Enter a valid email address.';
export const INVITE_CO_BORROWER_SUCCESS_MESSAGE = 'Invitation sent.';
export const INVITE_CO_BORROWER_ERROR_MESSAGE = 'Failed to send the invitation.';
export const INVITE_CO_BORROWER_SEPARATE_APPLICATION_LABEL = 'Create a Separate Application';
export const INVITE_CO_BORROWER_JOINT_HELPER_TEXT = 'The co-borrower will join this application.';
export const INVITE_CO_BORROWER_SEPARATE_HELPER_TEXT =
  'The co-borrower will complete their own private application.';
